/* eslint-disable */
import type { LocalizableString } from "../../cash/localization/localization.pb";
import type { Color } from "../../cash/ui/Color.pb";
import type { Image } from "../../cash/ui/Image.pb";

export interface UiAvatar {
  /**
   * The accent color to use as the background of the avatar if no photo is present.
   * If not specified, the client will fall back to using the Gray 85 color, #D9D9D9.
   * Optional.
   */
  background_color?: Color;
  /**
   * The monogram text to display in the middle of the avatar if no photo is present.
   * Currently only one character is allowed.
   * Optional.
   */
  monogram_text?: string;
  /**
   * The accessibility value to apply on the client.
   * Most likely the display name for the entity that the avatar represents.
   * Optional.
   */
  accessibility_value?: string;
  localizable_accessibility_value?: LocalizableString;
  /**
   * Light- and dark-themed URLs for the photo to display in the avatar, in place of a background color and monogram.
   * Optional.
   */
  image?: Image;
  /**
   * True if `image` is a template image and should be colorized/tinted.
   * `background_color` will also be shown when this is true.
   * Available in client versions >= 3.53.
   */
  is_template_avatar?: boolean;
  /** The remote badge image, available only to clients on version 3.56 and above. */
  badge_image?: Image;
  badge_shape?: UiAvatarBadgeShape;
}

export enum UiAvatarBadgeShape {
  /** CIRCULAR - Circular shape, which is the default. */
  CIRCULAR = "CIRCULAR",
  /** CARD - A card shape, used for gift cards. */
  CARD = "CARD",
}
